module.exports = __webpack_public_path__ + "static/media/app-store.c4d527a5.png";